import React from 'react';
import '../styles/Login.css';
import { auth, provider } from "../firebase";
import { useStateValue } from '../StateProvider';
import { actionTypes } from "../reducer"; 
import GoogleButton from 'react-google-button';

function Login() {

    const [state, dispatch] = useStateValue();

const signIn = () => {
    auth.signInWithPopup(provider).then(
        (result) => {
            console.log(result);
            dispatch({
                type: actionTypes.SET_USER,
                user: result.user,
            })
        })
        .catch((error) => {
            alert(error.message);
        })
}

    return (
        <div className="login">
            <div className="login-container">
                <img src="https://d34u8crftukxnk.cloudfront.net/slackpress/prod/sites/6/2019-01_BrandRefresh_Old-to-New-Final.gif"
                 alt=""/>
                <h1> Sign in to Cybertron </h1>
                <p>cybertron.slack.com</p>
                {/* <Button onClick={signIn}>Sign in with Google</Button> */}
                <GoogleButton className="signinButton" onClick={signIn}/>
            </div>
        </div>
    )
}

export default Login
